import type { AdminKpisPieLegendRowProps } from "../../models/admin-kpis.models";
import {
  getAdminKpisPressedButtonAriaProps,
  getAdminKpisSegmentSwatchColorClassName,
} from "../../utils/admin-kpis.utils";
import "./AdminKpisPie.css";
import { memo } from "react";
import { twMerge } from "tailwind-merge";

const AdminKpisPieLegendRow = ({ segment, isActive, onClick }: AdminKpisPieLegendRowProps) => {
  const className = twMerge(
    "mt-[1px] flex w-full min-w-0 items-baseline gap-2 rounded-sm border-0 bg-transparent px-1 py-1 text-left text-sm transition-colors",
    "hover:bg-[#F2F7F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#367C2B] dark:hover:bg-gray-700",
    isActive && "bg-[#E8F4E3] ring-1 ring-[#367C2B] dark:bg-gray-700",
  );
  const swatchClassName = twMerge(
    "mt-1 h-3 w-3 flex-none rounded-sm",
    getAdminKpisSegmentSwatchColorClassName(segment.code),
  );
  const handleClick = () => onClick(segment.code);
  const content = (
    <>
      <span className={swatchClassName} aria-hidden="true" />
      <span className="min-w-0 flex-1 break-words text-xs">{segment.label}</span>
      <span className="flex-none text-xs font-semibold">{segment.value}</span>
    </>
  );

  return (
    <button
      type="button"
      {...getAdminKpisPressedButtonAriaProps(isActive)}
      aria-label={`Show KPI details for ${segment.label}`}
      className={className}
      onClick={handleClick}
    >
      {content}
    </button>
  );
};

export default memo(AdminKpisPieLegendRow);
